var _linearGradient, _radialGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _linearGradient8, _linearGradient9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    stopColor: "#fca300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#f39600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e58200"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 243.5692466194,
    cy: 247.1763383654,
    gradientUnits: "userSpaceOnUse",
    r: 266.6335514318,
    xlinkHref: "#a"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0396,
    stopColor: "#e27f04",
    stopOpacity: 0.039216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#c15d2f",
    stopOpacity: 0.466667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#ad4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#c",
    y1: 215.5542008562,
    y2: 673.0149527154
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#c",
    y1: 317.9493256384,
    y2: -144.3336651556
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#c",
    y1: 263.7400474434,
    y2: 411.5853313628
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#c",
    y1: 311.9259944228,
    y2: 60.1678564416
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2837,
    stopColor: "#ffc534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#ffbf29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    stopColor: "#ffb417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 160.7497976996,
    cy: 186.9441305236,
    gradientUnits: "userSpaceOnUse",
    r: 358.3843924246,
    xlinkHref: "#h"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 235.671693422,
    cy: 256.00011,
    gradientUnits: "userSpaceOnUse",
    r: 224.1738751482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#fffcf8",
    stopOpacity: 0.05098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffcf8",
    stopOpacity: 0
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 274.3034,
    cy: 231.1439,
    gradientTransform: "matrix(.920094 0 0 1.003922 -.228091 0)",
    gradientUnits: "userSpaceOnUse",
    r: 291.1919,
    xlinkHref: "#a"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 183.6839942208,
    cy: 191.758137298,
    gradientUnits: "userSpaceOnUse",
    r: 273.03164673,
    xlinkHref: "#h"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 332.4379279424,
    x2: 158.7593215502,
    y1: 306.1939009794,
    y2: 266.0370209794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0206,
    stopColor: "#fea600",
    stopOpacity: 0.019608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    stopColor: "#ec8c00",
    stopOpacity: 0.635294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e58200"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 221.866762,
    x2: 284.7623749078,
    xlinkHref: "#a",
    y1: 256.00011,
    y2: 256.00011
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 91.371094 47.878906 171.546875 119.90625 216.847656h272.1875c72.027344-45.300781 119.90625-125.476562 119.90625-216.847656s-47.878906-171.546875-119.90625-216.847656h-272.1875c-72.027344 45.300781-119.90625 125.476562-119.90625 216.847656zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 65.183594 24.375 124.660156 64.488281 169.859375h383.023438c40.113281-45.199219 64.488281-104.675781 64.488281-169.859375s-24.375-124.660156-64.488281-169.855469h-383.023438c-40.113281 45.195313-64.488281 104.671875-64.488281 169.855469zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 38.097656 8.332031 74.242188 23.257812 106.730469h465.484376c14.925781-32.488281 23.257812-68.632813 23.257812-106.730469s-8.332031-74.242188-23.257812-106.730469h-465.484376c-14.925781 32.488281-23.257812 68.632813-23.257812 106.730469zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 22.050781 2.796875 43.445312 8.039062 63.859375h495.921876c5.242187-20.414063 8.039062-41.808594 8.039062-63.859375s-2.796875-43.445312-8.039062-63.859375h-495.921876c-5.242187 20.414063-8.039062 41.808594-8.039062 63.859375zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m235.671875.800781c-131.878906 10.363281-235.671875 120.65625-235.671875 255.199219s103.792969 244.835938 235.671875 255.199219c131.878906-10.363281 235.671875-120.65625 235.671875-255.199219s-103.792969-244.835938-235.671875-255.199219zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m248.921875 24.230469c-8.789063-1.195313-17.710937-1.195313-26.503906 0-114.132813 15.527343-202.09375 113.375-202.09375 231.769531s87.960937 216.242188 202.09375 231.769531c8.792969 1.195313 17.714843 1.195313 26.503906 0 114.136719-15.527343 202.097656-113.375 202.097656-231.769531s-87.960937-216.242188-202.097656-231.769531zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m405.820312 256c0-103.15625-76.644531-186.78125-171.1875-186.78125-94.546874 0-171.191406 83.625-171.191406 186.78125s76.644532 186.78125 171.191406 186.78125c94.542969 0 171.1875-83.625 171.1875-186.78125zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m281.632812 76.359375c-21.3125-6.625-44.078124-6.625-65.390624 0-71.691407 22.285156-124.191407 94.269531-124.191407 179.640625 0 87.039062 54.574219 160.167969 128.421875 180.890625 18.597656 5.21875 38.332032 5.21875 56.929688 0 73.847656-20.722656 128.417968-93.847656 128.417968-180.890625 0-85.371094-52.496093-157.355469-124.1875-179.640625zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m403.867188 284.285156-113.320313-113.324218c-2.058594-3.582032-6.332031-6.542969-12.832031-8.878907-6.671875-2.394531-13.78125-4.023437-21.3125-4.921875l-9.945313-8.871094c-.199219-1.402343-1.019531-2.675781-2.542969-3.800781-1.757812-1.289062-3.652343-1.941406-5.679687-1.941406-2.214844 0-4.113281.652344-5.679687 1.941406-1.570313 1.292969-2.355469 2.769531-2.355469 4.429688v8.035156c-14.960938 1.664063-27.476563 6.648437-37.539063 14.960937-10.070312 8.3125-15.101562 20.492188-15.101562 36.535157 0 5.714843.644531 10.921875 1.941406 15.625 1.289062 4.699219 3.414062 8.800781 6.371094 12.300781 2.953125 3.503906 5.773437 6.5 8.449218 8.988281.140626.132813.300782.261719.449219.394531l35.429688 35.511719v46.347657c-8.183594-.554688-15.394531-2.671876-21.628907-6.359376-6.230468-3.683593-11.128906-7.140624-14.695312-10.367187s-6.445312-4.839844-8.632812-4.839844c-3.308594 0-6.246094 1.75-8.816407 5.253907-2.570312 3.503906-3.851562 7.003906-3.851562 10.507812 0 5.738281 3.328125 11.394531 9.960937 16.964844l97.378906 97.378906c64.460938-19.242188 113.746094-78.550781 123.953126-151.871094zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m172.570312 321.8125c0-3.503906 1.285157-7.003906 3.855469-10.507812 2.570313-3.5 5.507813-5.253907 8.816407-5.253907 2.1875 0 5.066406 1.613281 8.632812 4.839844 3.566406 3.230469 8.464844 6.683594 14.695312 10.367187 6.234376 3.691407 13.445313 5.808594 21.628907 6.359376v-64.972657c-5.539063-2.023437-9.792969-3.640625-12.742188-4.839843-2.957031-1.191407-6.882812-2.945313-11.777343-5.25-4.894532-2.300782-8.683594-4.699219-11.359376-7.1875-2.675781-2.492188-5.496093-5.484376-8.445312-8.988282-2.960938-3.503906-5.082031-7.601562-6.375-12.304687-1.292969-4.699219-1.9375-9.90625-1.9375-15.621094 0-16.042969 5.027344-28.226563 15.097656-36.535156 10.066406-8.3125 22.578125-13.300781 37.539063-14.960938v-8.035156c0-1.664063.785156-3.140625 2.355469-4.433594 1.566406-1.289062 3.464843-1.9375 5.679687-1.9375 2.03125 0 3.921875.648438 5.679687 1.9375 1.753907 1.292969 2.632813 2.769531 2.632813 4.433594v7.480469c11.261719.371094 21.652344 2.261718 31.167969 5.679687 9.511718 3.417969 14.269531 8.171875 14.269531 14.265625 0 3.324219-1.121094 6.789063-3.355469 10.390625-2.234375 3.601563-5.21875 5.402344-8.941406 5.402344-1.472656 0-5.519531-1.566406-12.132812-4.710937-6.621094-3.136719-13.621094-4.988282-21.007813-5.539063v56.144531c7.347656 2.765625 13.453125 5.394532 18.320313 7.882813 4.867187 2.488281 10.011718 5.945312 15.433593 10.367187 5.417969 4.425782 9.503907 10 12.257813 16.726563 2.753906 6.726562 4.132812 14.609375 4.132812 23.640625 0 16.5-4.5 29.617187-13.5 39.347656-9.003906 9.734375-21.214844 15.710938-36.644531 17.9375v9.253906c0 1.632813-.878906 3.082032-2.632813 4.355469-1.757812 1.269531-3.648437 1.902344-5.675781 1.902344-2.21875 0-4.113281-.636719-5.683593-1.898438-1.570313-1.273437-2.351563-2.722656-2.351563-4.355469v-8.429687c-16.070313-.183594-29.695313-3.859375-40.867187-11.03125-11.179688-7.164063-16.765626-14.472656-16.765626-21.921875zm32.417969-116.121094c0 7.1875 2.238281 12.671875 6.714844 16.449219s11.199219 7.328125 20.15625 10.644531v-50.367187c-17.914063 2.214843-26.871094 9.972656-26.871094 23.273437zm39.894531 121.371094c16.25-2.949219 24.382813-12.070312 24.382813-27.371094 0-8.105468-2.128906-14.46875-6.375-19.074218-4.25-4.605469-10.25-8.570313-18.007813-11.890626zm0 0",
    fill: "url(#n)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoin);
export default __webpack_public_path__ + "static/media/icon-coin.7373dac297a5b2c2ce28997feab86a9e.svg";
export { ForwardRef as ReactComponent };